export default __webpack_public_path__ + "static/media/affligem_l3.af7ff421.png";